export default "__VITE_ASSET__0z4rM7V1__"